import * as firebase from "firebase/app";
import { getDatabase } from "firebase/database";

/*
Prod database connection
 */
const firebaseConfig = {
  apiKey: "AIzaSyDDxDX6H87VVUYN0UbOpmmyvtpBzioiTaA",
  authDomain: "psi-works-backoffice.firebaseapp.com",
  databaseURL:
    "https://psi-works-backoffice-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "psi-works-backoffice",
  storageBucket: "psi-works-backoffice.appspot.com",
  messagingSenderId: "17152335131",
  appId: "1:17152335131:web:169e8562902a4e734447be",
};

if (!firebase.getApps().length) {
  firebase.initializeApp(firebaseConfig);
} else {
  firebase.getApp(); // if already initialized, use that one
}

const database = getDatabase(firebase.getApp());
const firebaseApp = firebase.getApp();

export { firebaseApp, database };
